export interface MenuLink {
  label: string;
  title: string;
  url: string;
}

export enum Locale {
  en = 'en-US',
  nl = 'nl-NL',
}

export interface ImageInfo {
  id: string;
  name: string;
  url: string;
}

export interface TableOfContentsItem {
  label: string;
  linkedElement: HTMLElement;
  children?: TableOfContentsItem[];
  active?: boolean;
}

export interface TocElementWithLevel {
  element: HTMLHeadingElement;
  level: number;
}

export enum ContentfulGripContentTypes {
  gripDocumentationArticles = 'gripDocumentationArticles',
  gripBlogArticles = 'gripBlogArticles',
  gripFaq = 'gripFaq',
  faqPage = 'faqPage',
  about = 'about',
}

export interface RouteTitle {
  en: string;
  nl: string;
}
